import { RouterModule_encodeQueryString, RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { isEmpty, ofArray, choose, singleton } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { join } from "./fable_modules/fable-library-js.4.29.0/String.js";
import { equalsWith, map } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { defaultOf, int32ToString } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { map as map_1 } from "./fable_modules/fable-library-js.4.29.0/Option.js";

export function formatSearchRoute(searchTerm) {
    return RouterModule_encodeParts(singleton("arrangement" + RouterModule_encodeQueryString(singleton(["sok", searchTerm]))), 1);
}

export function formatOnlyEligibleRoute() {
    return RouterModule_encodeParts(singleton("arrangement" + RouterModule_encodeQueryString(singleton(["kunTilgjengelige", "true"]))), 1);
}

export function formatLevelsRoute(levelIds) {
    return RouterModule_encodeParts(singleton("arrangement" + RouterModule_encodeQueryString(singleton(["nivaer", join(",", map(int32ToString, levelIds))]))), 1);
}

export function formatCoursesRoute(courseIds) {
    return RouterModule_encodeParts(singleton("arrangement" + RouterModule_encodeQueryString(singleton(["kurs", join(",", map(int32ToString, courseIds))]))), 1);
}

export function formatRegionsRoute(regionIds) {
    return RouterModule_encodeParts(singleton("arrangement" + RouterModule_encodeQueryString(singleton(["regioner", join(",", map(int32ToString, regionIds))]))), 1);
}

/**
 * Construct a link with query parameters for the list event view
 */
export function formatRoute(searchTerm, showOnlyEligible, levelIds, courseIds, regionIds) {
    const _arg = choose((x_3) => x_3, ofArray([map_1((term) => ["sok", term], searchTerm), showOnlyEligible ? ["kunTilgjengelige", "true"] : undefined, (!equalsWith((x, y) => (x === y), levelIds, defaultOf()) && (levelIds.length === 0)) ? undefined : ["nivaer", join(",", map(int32ToString, levelIds))], (!equalsWith((x_1, y_1) => (x_1 === y_1), courseIds, defaultOf()) && (courseIds.length === 0)) ? undefined : ["kurs", join(",", map(int32ToString, courseIds))], (!equalsWith((x_2, y_2) => (x_2 === y_2), regionIds, defaultOf()) && (regionIds.length === 0)) ? undefined : ["regioner", join(",", map(int32ToString, regionIds))]]));
    if (isEmpty(_arg)) {
        return RouterModule_encodeParts(singleton("arrangement"), 1);
    }
    else {
        return RouterModule_encodeParts(singleton("arrangement" + RouterModule_encodeQueryString(_arg)), 1);
    }
}

//# sourceMappingURL=QueryParameters.jsx.map
